import { gql } from "graphql-request";

export const project = {
  projectCounts: gql`
    query ProjectCounts($projectId: String!) {
      projectCounts(projectId: $projectId) {
        tasksCount
        membersCount
      }
    }
  `,

  getProjectParticipants: gql`
    query ProjectParticipants($projectArn: String!) {
      projectParticipants(projectArn: $projectArn) {
        decisionDate
        decisionStatus
        isSponsorLocked
        participationType
        submissionDate
        tenantId
      }
    }
  `,
};
